var React = require('react');

function Document (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Document"),React.createElement("g",{"id":"brLayer_1","key":1},[React.createElement("path",{"d":"M37.7 28.9h-16c-.6 0-1 .4-1 1s.4 1 1 1h16c.6 0 1-.4 1-1s-.5-1-1-1zm0 7h-16c-.6 0-1 .4-1 1s.4 1 1 1h16c.6 0 1-.4 1-1s-.5-1-1-1zm0 7h-16c-.6 0-1 .4-1 1s.4 1 1 1h16c.6 0 1-.4 1-1s-.5-1-1-1z","key":0}),React.createElement("path",{"d":"M43.6 13.2c-4.7-5.4-7-5.3-7.9-5.3h-17c-3.9 0-6.3 3.1-6.3 6.9v32c0 3.9 2.5 7.1 6.3 7.1h22c3.9 0 7.7-3.2 7.7-7.1v-26c0-.6-.4-2.5-4.8-7.6zm1.8 33.6c0 2.2-2.5 4.1-4.7 4.1h-22c-2.2 0-3.3-1.9-3.3-4.1v-32c0-2.2 1.1-3.9 3.3-3.9h15.7v5.9c0 3.9 1.5 6.1 5.3 6.1h5.7v23.9zm-5.7-25.9c-2.2 0-3.3-1.9-3.3-4.1v-6c2 0 8.3 8.1 8.3 10.1h-5z","key":1})])]);
}

Document.defaultProps = {"viewBox":"0 0 60 61.8","id":"document","width":"100%","height":"100%"};

module.exports = Document;

Document.default = Document;
